

















































import Vue from 'vue'
import { mapActions } from 'vuex'
import SubPage from '@/components/SubPage.vue'
import SubHeader from '@/components/SubHeader.vue'
import { VueEditor } from 'vue2-editor'
import head from '@/mixins/Head'

export default Vue.extend({
  components: { SubPage, SubHeader, VueEditor },
  mixins: [head],
  data() {
    return {
      head: {
        link: 'https://camp-go.jp/news/',
        title: '新着情報',
        description:
          'キャンプ用品レンタルならCAMP GO RENTAL（キャンプゴーレンタル）は、キャンプ用品をレンタルして、お手軽キャンプ。道の駅やキャンプ場・自宅でキャンプ用品を受取ができます。',
      },
      topics: [],
      content: [],
    }
  },
  created() {
    this.recentPosts().then(topics => {
      this.topics = topics
    })
    this.loadPage(this.$route.params.id)
  },
  beforeRouteUpdate(to, from, next) {
    // 同一画面内の遷移なので、beforeRouteUpdate で再取得
    const loadId = to.params.id
    next()
    this.loadPage(loadId)
  },
  methods: {
    ...mapActions('topic', {
      recentPosts: 'recent_posts',
      show: 'show',
    }),
    loadPage(id: string) {
      this.show({ id: id }).then(content => {
        this.head.title = content.title
        this.content = content
      })
    },
  },
})
